import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	SECURITY_LEVEL_TYPE,
	SECURITY_LEVEL_TYPE_OVERRIDE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import {
	transformAggNodeToLegacyField,
	transformAggConnection,
} from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const transformJiraSecurityLevel = (securityLevel) => {
	if (securityLevel == null) return null;

	return {
		id: securityLevel.securityId,
		description: securityLevel.description || '',
		name: securityLevel.name || '',
	};
};

export const transformAggSecurityLevelToLegacyField: FieldTransformer = (node) => ({
	...transformAggNodeToLegacyField(node),
	value: transformJiraSecurityLevel(node.securityLevel),
	allowedValues: transformAggConnection(node.securityLevels, transformJiraSecurityLevel),
	schema: {
		configuration: null,
		type: SECURITY_LEVEL_TYPE_OVERRIDE,
		renderer: PLAIN_TEXT,
		custom: null,
		system: SECURITY_LEVEL_TYPE,
		items: null,
	},
});
